/*
 * @Author: yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-07-21 21:26:07
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-10-20 16:34:38
 * @FilePath: \mpc-2\features\mpc-common\src\features\MPCDemand\DemandConfigQuoteTable\quoteDrawer.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useRef, useMemo, useState, useEffect } from 'react';
import { useMemoizedFn, useSize } from 'ahooks';
import { Drawer, Button, Space, Message, Typography, Modal, Dropdown, Menu } from '@bedrock/components';
import { AlertCircle, CheckCircle, SignOut, SignInFilled, Save, Delete, ChevronDown, Download } from '@bedrock/icons-react'
import CurrencyType from '#components/SForm/SFormElement/CurrencyType';
import DemandConfigQuoteTable from './index';
import dayjs from 'dayjs';
import {
  createRowByCooperateAccountId,
  QuoteTableType,
  localDataToServerData,
  getTotalPrice,
  createPreFillValueWithStandardId,
} from './handleQuoteColumns';
import { apiService, defs } from '#services';
import withFunctionCall from '#utils/withFunctionCall';
import { useImportFileModal } from '#features/importFileModal';

type OpenQuoteModalProps = React.ComponentProps<typeof Drawer> & {
  quoteTableType: QuoteTableType;
  templateType: number;
  title?: string;
  quoteTableColumns?: defs.DemandQuoteTableColumnDto[];
  cooperateAccountList: defs.DemandCooperateAccountDto[];
  readOnly?: boolean;
  onTempSave?: (data: any[]) => void;
  onCommit?: (data: any[]) => void;
  data?: any[];
  onOk?: () => void;
  onCancel?: () => void;
  onClose?: () => void;
  supplierId?: number;
  demandId?: number;
  currency?: string;
  lastTempSaveTime?: string;
  addTemplateList?: any[];
  categoryId?: number; // 三级需求类型id
};

const QuoteTableDrawer = (props: OpenQuoteModalProps) => {
  const [
    {
      quoteTableType,
      templateType,
      readOnly,
      title,
      quoteTableColumns = [],
      cooperateAccountList,
      data = [],
      onTempSave,
      onCommit,
      onClose,
      onOk,
      onCancel,
      supplierId,
      demandId,
      categoryId,
      currency = 'cny',
      lastTempSaveTime,
      addTemplateList = [],
      ...restProps
    },
    setProps,
  ] = useState(props);
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [value, onChange] = useState(data);
  const [localTempSaveTime, setLocalTempSaveTime] = useState(lastTempSaveTime);
  const [columns, setColumns] =
    useState<defs.DemandQuoteTableColumnDto[]>(quoteTableColumns);
  const tableRef =
    useRef<React.ComponentRef<typeof DemandConfigQuoteTable>>(null);

  const initColumns = useMemoizedFn(() => {});

  const hideFooter = useMemo(() => {
    return quoteTableType === 'prefill' && templateType === 1;
  }, [quoteTableType, templateType]);

  const importDataToTable = useMemoizedFn((list: any[]) => {
    // 根据不可编辑字段，从根据"cooperateAccountId"从addTemplateList中配 不可编辑的字段覆盖list中的值
    const unEditableColumns = tableRef.current?.unEditableColumns || [];
    const unEditableColumnsMap = unEditableColumns.reduce((acc: any, curr: any) => {
      acc[curr.dataIndex] = curr;
      return acc;
    }, {});
    const newList = list.map((item: any) => {
      const template = addTemplateList.find((n: any) => n.cooperateAccountId == item.cooperateAccountId);
      if(template) {
        Object.keys(unEditableColumnsMap).forEach((key: any) => {
          item[key] = template[key];
        });
      }
      if(item.l2$subDataId) {
        // 判断item是否还有其他l2$开头的属性，且属性都为空，如果是，则删除l2$subDataId
        let l2ValueKeys = []
        Object.keys(item).forEach((key: any) => {
          if(key.startsWith('l2$') && key !== 'l2$subDataId' && (!!item[key] || item[key] === 0)) {
            l2ValueKeys.push(key);
          }
        });
        if(l2ValueKeys.length === 0) {
          delete item.l2$subDataId;
        }
      }
      return item;
    });
    
    tableRef.current?.initData(newList);
  })

  const { openImportFileModal, closeImportFileModal } = useImportFileModal({
    importIsMemory: false,
    showSuccessToast: false,
    uploadFinishedCallback(res) {
      if (res.code === 1 && res?.data?.fail_count === 0 && res?.data?.ext_data?.data?.length) {
        let list = res?.data?.ext_data?.data || [];
        // 根据cooperateAccountId转map
        const cooperateAccountIdListMap = list.reduce((acc: any, curr: any) => {
          if(!acc[curr.cooperateAccountId]) {
            acc[curr.cooperateAccountId] = [curr];
          } else {
            acc[curr.cooperateAccountId].push(curr);
          }
          return acc;
        }, {});
        // 过滤没有的合作内容id

        let successNumber = 0;
        const newList = cooperateAccountList.reduce((acc: any, curr: any) => {
          if(cooperateAccountIdListMap[curr.id]) {
            acc.push(...cooperateAccountIdListMap[curr.id]);
            successNumber += cooperateAccountIdListMap[curr.id].length;
          } else {
            acc.push({
              cooperateAccountId: curr.id,
            });
          }
          return acc;
        }, []);
        importDataToTable(newList);
        closeImportFileModal();
        if(successNumber !== list.length) {
          Message.error(`部分导入失败，请检查合作内容是否存在，成功导入${successNumber}条，失败${list.length - successNumber}条`);
          return;
        } else {
          Message.success(`导入成功，成功导入${successNumber}条`);
        }
      }
    },
  });

  const totalPrice = useMemo(() => {
    // 根据quoteKey去重
    let addPrice = 0;
    let addedKeyMap: any = {};
    value.forEach((item) => {
      if (!addedKeyMap[item.quoteKey]) {
        addedKeyMap[item.quoteKey] = true;
        addPrice += getTotalPrice(item);
      }
    });
    return addPrice?.toFixed?.(2) || 0;
  }, [value]);
  const size = useSize(document.querySelector('body'));

  useEffect(() => {
    initColumns();
    setTimeout(() => {
      setReady(true);
    }, 100);
  }, []);

  const clearData = useMemoizedFn(() => {
    Modal.confirm({
      title: '确定一键清空所有明细行吗？',
      content: '将删除每个合作内容第一行外的多余明细行',
      onOk: () => {
        // 根据当前数据，每个合作内容id保留一条数据，其他数据删除
        const cooperateAccountIdMap = {}
        const newList = value.reduce((acc: any, curr: any) => {
          if(!cooperateAccountIdMap[curr.cooperateAccountId]) {
            acc.push(curr);
            cooperateAccountIdMap[curr.cooperateAccountId] = true;
          }
          return acc;
        }, []);
        importDataToTable(newList);
      }
    })
  })

  const [batchDeleteMode, setBatchDeleteMode] = useState(false);
  const toggleBatchDeleteMode = useMemoizedFn(() => {
    setBatchDeleteMode(!batchDeleteMode);
    tableRef.current?.setSelectedRows?.([]);
  })

  const handleBatchDeleteRowsOk = () => {
    tableRef.current?.handleBatchDeleteRows?.();
    setTimeout(() => {
      toggleBatchDeleteMode();
      Message.success('删除成功');
    }, 600)
  }

  const titleExtraButtons = useMemo(() => {
    if (!!onCommit && !hideFooter && !batchDeleteMode) {
      return [
        (
          <Dropdown overlay={(
            <Menu selectedKeys={[]} >
              <Menu.Item key="A" onClick={() => clearData() }>一键清空</Menu.Item>
              <Menu.Item key="B" onClick={() => toggleBatchDeleteMode() }>批量勾选删除</Menu.Item>
            </Menu>
          )}>
            <Button size="medium" danger icon={<Delete />}
              suffixIcon={<ChevronDown className="rock-dropdown-down-arrow-icon"/>}
            >
              清空明细行
            </Button>
          </Dropdown>
      ),
        <Button type="checked-neutral" icon={<SignOut />} onClick={() => {
          if (quoteTableType === 'supplierQuote') {
            apiService.outsourceDemandExportQuoteTableData({
              demand_id: demandId,
              supplier_id: supplierId,
              data: localDataToServerData(value),
            }, { dataType: 'blob', filename: 'MPC报价总明细.xlsx' });
          }
          if (quoteTableType === 'prefill') {
            apiService.demandExportQuoteTableData({
              demand_id: demandId,
              l3_category_id: categoryId,
              data: localDataToServerData(value),
            }, { dataType: 'blob', filename: 'MPC报价预填明细.xlsx' });
          }
        }}>导出</Button>,
        <Button type="checked" icon={<SignInFilled />} onClick={() => {
          if (quoteTableType === 'supplierQuote') {
            openImportFileModal({
              customDownloadRender: () => (
                <>
                </>
              ),
              limit: 999,
              importType: `demand_supplier_quote_table_data_${demandId}`
            });
          }
          if (quoteTableType === 'prefill') {
            openImportFileModal({
              customDownloadRender: () => (
                <>
                  <Button icon={<Download />} type='link'
                    onClick={() => {
                      // 使用前端初始化的数据进行模版导出；
                      return apiService.demandExportQuoteTableData({
                        demand_id: demandId,
                        l3_category_id: categoryId,
                        data: createPreFillValueWithStandardId(columns, cooperateAccountList),
                      }, { dataType: 'blob', filename: 'MPC报价预填明细.xlsx' });
                      // apiService.demandExportQuoteTableData({
                      //   demand_id: demandId,
                      //   l3_category_id: categoryId,
                      //   data: [],
                      // }, { dataType: 'blob', filename: 'MPC报价预填明细.xlsx' })
                    }}
                  >下载模板</Button>
                  <span className="download-span fs-12 m-l-4">(上传前请先下载Excel模板并按照模板格式编辑文件，或先导出当前表格编辑后再导入)</span>
                </>
              ),
              limit: 999,
              importType: `demand_prefill_quote_table_data_${demandId}_${categoryId}`
            });
          }
        }}>导入</Button>,
      ]
    }
    return [];
  }, [quoteTableType, onCommit, demandId, supplierId, value, hideFooter, categoryId, batchDeleteMode]);

  const drawerTitle = batchDeleteMode ? (
    <Space size={8} align='baseline'>
      <span>批量删除行</span>
      <Typography.Text type="warning">
        <AlertCircle />请勾选要删除的行，点击确定删除
        </Typography.Text>
    </Space>
  ) : (
    title || <Space size={8} align='baseline'>
        <span>报价总明细</span>
          {quoteTableType === 'supplierQuote' 
          && <Typography.Text type="warning">
              <AlertCircle /> 
            可对预填信息进行编辑/添加/删除
            {templateType === 1 && '，可点击按钮【添加分发平台】'}
          </Typography.Text>}
      </Space>
  )

  return (
    <Drawer
      {...restProps}
      placement="bottom"
      visible={true}
      maskClosable={false}
      bodyStyle={{
        paddingTop: 0,
      }}
      title={drawerTitle}
      onClose={() => {
        onClose?.();
        onCancel?.();
      }}
      titleExtra={titleExtraButtons}
      footer={
        !hideFooter && (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Space size={4}>
              <Typography.Text type="secondary">报价金额-优惠前 (含税+服务费):</Typography.Text>
              <CurrencyType
                view
                value={{
                  value: totalPrice,
                  currency: currency
                }} />
            </Space>
            {!batchDeleteMode && 
            <Space size={12}>
              {!!onTempSave && (<>
                {localTempSaveTime && <Typography.Text type="secondary"><CheckCircle /> {localTempSaveTime} 已保存</Typography.Text>}
                <Button
                  loading={loading}
                  icon={<Save />}
                  onClick={async () => {
                    try {
                      setLoading(true);
                      await onTempSave?.(localDataToServerData(value));
                      // 日期格式化，格式为yyyy-MM-dd HH:mm:ss
                      setLocalTempSaveTime(dayjs().format('YYYY-MM-DD HH:mm:ss'));
                      Message.info('暂存成功');
                      setLoading(false);
                    } catch (error) {
                      setLoading(false);
                    }
                  }}
                >
                  暂存
                </Button>
              </>
              )}
              {!!onCommit && (
                <Button
                  type="primary"
                  loading={loading}
                  onClick={async () => {
                    setLoading(true);
                    tableRef.current?.validateFields()
                      .then(async (data) => {
                        const listData = localDataToServerData(value);
                        // 如果是策划预填环节，必须要保证所有cooperateAccountList的id都存在listData中，如果listData里没有则提示那个合作内容没有数据
                        if(quoteTableType === 'prefill') {
                          const missingCooperateAccountIdList = cooperateAccountList
                            .filter((item) => !listData.some((n) => n.cooperateAccountId == item?.id))
                            .map((item) => `合作内容${item.index_id}`);
                          if(missingCooperateAccountIdList.length > 0) {
                            Message.error(`${missingCooperateAccountIdList.join(',')} 没有数据`);
                            return;
                          }
                        }
                        setLoading(true);
                        try {
                          await onCommit?.(listData);
                          Message.info('提交成功');
                          setLoading(false);
                        } catch (error) {
                          setLoading(false);
                        }
                    }).catch(error => {
                        Message.error('请完善报价信息');
                    }).finally(() => {
                      setLoading(false);
                    });
                  }}
                >
                  提交
                </Button>
              )}
            </Space>}
            {batchDeleteMode && (
              <Space>
                <Button loading={loading} onClick={toggleBatchDeleteMode} >取消</Button>
                <Button danger type="primary" loading={loading} onClick={handleBatchDeleteRowsOk} >确定删除</Button>
              </Space>
            )}
          </div>
        )
      }
    >
      <div style={{ height: 'calc(100vh - 170rem)' }}>
        {!!value?.length && (
          <DemandConfigQuoteTable 
            forceMeasureColumnWidth={true}
            templateType={templateType}
            readOnly={readOnly}
            ref={tableRef}
            value={value}
            quoteTableType={quoteTableType}
            scroll={{ x: 'max-content', y: size?.height - 230 }}
            onChange={onChange}
            quoteTableColumns={columns}
            cooperateAccountList={cooperateAccountList}
            addTemplateList={addTemplateList}
            customScrollbarSize={8}
            batchDeleteMode={batchDeleteMode}
          />
        )}
      </div>
    </Drawer>
  );
};

export const QuoteTableDrawerOpen = withFunctionCall(QuoteTableDrawer);
